<template>
  <div class="page-body overflow-visible">
    <template v-if="isBusy || (items && items.length > 0)">
      <div class="page-table-container overflow-visible">
        <b-table
          id="location-work-services"
          ref="location_work_services"
          class="custom-table mb-0"
          :busy.sync="isBusy"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(work_service)="row">
            <work-service-select
              id="work-service-select"
              ref="work_service_select"
              :is-disabled="isDisabled"
              :value="row.item.work_service_id"
              @onSelect="onSelectWorkService($event, row)"
            />
          </template>

          <template #cell(price)="row">
            <b-form-input
              id="input-price"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              type="number"
              v-model.number="row.item.price"
            />
          </template>

          <template #cell(unit)="row">
            <unit-select
              id="input-unit"
              ref="unit_select"
              :is-disabled = "isDisabled"
              :initial-unit="row.item.unit_code"
              is-short
              @selectUnit="onSelectUnit($event, row)"
            />
          </template>

          <template #head(action)="row">
            <b-btn variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click.stop="onAdd()">
              <v-icon name="buttons/plus" :size="12" class="mr-1"/>
              Добавить
            </b-btn>
          </template>

          <template #cell(action)="row">
            <b-button variant="link" @click="onRemove(row)" :disabled="isDisabled">
              <v-icon name="buttons/trash" :size="16"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="page-pagination">
        <pagination-footer
          :total-rows="items.length"
          :per-page="perPage"
          :current-page.sync="currentPage"
          @per-page-change="onPerPageChange"
        />
      </div>
    </template>

    <div v-else class="empty-state-container">
      <v-icon name="navbar/empty_table" :size="90"/>
      <h5>Нет добавленных услуг.</h5>
      <p>Добавьте услуги исполнителей прямо сейчас</p>
      <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAdd()">
        <v-icon name="buttons/plus" :size="12" class="mr-1"/>
        Новая услуга
      </b-btn>
    </div>
  </div>
</template>

<script>
import helpers from "../../utilites/helpers";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import WorkServiceSelect from "../Catalogs/WorkServices/WorkServiceSelect";
  import UnitSelect from "../Catalogs/UnitSelect";

export default {
  name: "LocationWorks",
  components: { PaginationFooter, WorkServiceSelect, UnitSelect },
  mixins: [ helpers ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'work_service',
          label: 'Вид услуг',
          sortable: false
        },
        {
          key: 'price',
          label: 'Стоимость услуг',
          class: 'location-work-services-width',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: 'location-work-services-width',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-work-services-action',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      deleteRow: {
        id: null,
        work_service_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId, items) {
      this.items = items;
      this.locationId = locationId;
    },
    onAdd() {
      const data = {
        id: 0,
        location_id: this.locationId,
        work_service_id: 0,
        work_service_name: '',
        price: 0,
        unit_code: '539',
      };
      this.items.unshift(data);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = 'Удаление услуги исполнителя';
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.work_service_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    onSelectWorkService(workService, row) {
      if (workService != null) {
        row.item.work_service_id = workService.id;
        row.item.work_service_name = workService.name;
      } else {
        row.item.work_service_id = 0;
        row.item.work_service_name = "";
      }
    },
    // Единицы измерения
    onSelectUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    showHint() {
      this.showToast('Эти данные будут отображаться в Баланс-PRO.', 'Подсказка', 'info')
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style>
.location-work-services-width {
  width: 200px;
}

.location-work-services-action {
  width: 140px;
}

#location-work-services td {
  text-align: center;
}

#location-work-services th {
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorkServices.vue